function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

const service_tier_list = () => {
    var circleActive = false;
    var slickSlider;

    if (checkScreenSize(965)) {
        $(".circle.item-0").removeClass("active");
        $(".circle.item-0").find(".circle-active").remove();
        $('.box.box-0').removeClass("active");
    }

    slickSlider = $(".mobile-slider").slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: "22px",
        arrows: false,
        dots: false,
        variableWidth: true,
    });

    $(".circle").hover(function () {
        if (checkScreenSize(965)) {
            return false;
        }

        let num = parseInt(
            $(this)
                .attr("class")
                .replace(/[^0-9.]+/, "")
                .replace(/[^0-9.]+/, "")
        );

        $(".circle").not(this).removeClass("active");

        $(".circle")
            .not(this)
            .each(function () {
                $(this).find(".circle-active").remove();
            });

        $(`.box.active:not(.item-${num})`).removeClass("active");

        $(this).addClass("active");
        if (!$(this).children(".circle-active").length) {
            $(this).append('<div class="circle-active"></div>');
        }

        $(`.box-${num}`).addClass("active");
        circleActive = true;
    }, function () {
        $(".circle").removeClass("active");

        $(".circle").each(function () {
            $(this).find(".circle-active").remove();
        });

        $('.box.active').removeClass("active");
    });

    if (checkScreenSize(965)) {
        $(".circle").removeClass("active");
        $(".circle.item-0").addClass("active");
        $(".circle.item-0").append('<div class="circle-active"></div>');
        slickSlider.slick("slickGoTo", 0);
    }

    slickSlider.on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
            $(".circle.active").each(function () {
                $(this).find(".circle-active").remove();
            });
            $(".circle").removeClass("active");
            $(".circle.item-" + currentSlide).addClass("active");
            $(".circle.item-" + currentSlide).append(
                '<div class="circle-active"></div>'
            );
        }
    );

    $(window).on(
        "resize",
        debounce(function () {
            if (checkScreenSize(965)) {
                $(".circle.active").each(function () {
                    $(this).find(".circle-active").remove();
                });
                $(".circle").removeClass("active");
                $(".circle.item-0").addClass("active");
                $(".circle.item-0").append('<div class="circle-active"></div>');
                if (checkScreenSize(965)) {
                    $(".circle").removeClass("active");
                    $(".circle.item-0").addClass("active");
                    $(".circle.item-0").append('<div class="circle-active"></div>');
                    slickSlider.slick("slickGoTo", 0);
                }
            }
        }, 150)
    );

    function checkScreenSize(size) {
        if ($(window).width() >= size) {
            return false;
        }
        return true;
    }

    // Service tier list table modal event
    // Global variable to track the currently open modal
    var $currentOpenModal = null;

    $('.show-list-modal').on('click', function () {
        var $parentServiceTableRow = $(this).closest('.service-table-row');
        var $modal = $(this).siblings('.tier-list-modal');

        // Close any currently open modal that is not the clicked one
        if ($currentOpenModal && $currentOpenModal[0] !== $modal[0]) {
            $currentOpenModal.fadeOut();
            $currentOpenModal.closest('.service-table-row').css({ 'z-index': '1' });
        }

        // Toggle the modal for the clicked row
        $parentServiceTableRow.css({ 'z-index': '9' });
        $modal.fadeToggle();

        // Update the current open modal variable
        if ($modal.is(':visible')) {
            $currentOpenModal = $modal;
        } else {
            $currentOpenModal = null;
        }
    });

    $('.tier-list-modal--close').on('click', function () {
        var $parentServiceTableRow = $(this).closest('.service-table-row');
        var $modal = $(this).parents('.tier-list-modal');

        $parentServiceTableRow.css({ 'z-index': '1' });
        $modal.fadeToggle();

        // Reset the global variable if this modal was the current open one
        if ($currentOpenModal && $currentOpenModal[0] === $modal[0]) {
            $currentOpenModal = null;
        }
    });


};

export default service_tier_list;